import React from 'react'
import { SelectField } from '@app-soga/forms'
import { withGridContext } from '../providers'
import { ContextType } from '../types/advanced-grid.types'

/**
 * Component to control the total records displayed by page
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const PageSizeControl: React.FC<ContextType> = ({
    gridId,
    events,
    pageSize,
    recordsPerPageValues,
    loading,
    dataLoaded
}) => {
    const { handlePageSizeChange } = events || {}
    if (!dataLoaded) {
        return null
    }
    return (
        <>
            <SelectField
                disableGroup
                disabled={loading}
                id={`page-size-control-${gridId}`}
                onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                    handlePageSizeChange ? handlePageSizeChange(parseInt(value, 10)) : null
                }}
                options={
                    recordsPerPageValues
                        ? recordsPerPageValues.map((item) => ({ label: `${item}`, value: item }))
                        : []
                }
                value={pageSize}
            />
        </>
    )
}

export default withGridContext(PageSizeControl)
